export default "__VITE_ASSET__3fc5251c__"